export enum TrailFeatureRelations {
  trails = 'trails',
}
